import React from 'react'
import { FiArrowRight } from 'react-icons/fi';
import Navbar from '../@shared/navigations/default';

export const NotFoundPage = () => {

    return (
        <React.Fragment>
            <Navbar />
            <div id="notfound">
                <div className="flex-center notfound">
                    <div className='flex-column'>
                        <h1 className='error'>404</h1>
                        <p className='message'> Page Not Found</p>
                        <div>
                            <a href='/' className='button'><p>Return back</p> <FiArrowRight size={25} /></a>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default NotFoundPage;

